module.exports = __webpack_public_path__ + "static/media/Torino.a480782e.png";